import type {
  InterstateOnChangeEvent,
  SearchInputChangeEventValue
} from "@dealer-center/core-components";
import {
  FilterInput,
  IconButton,
  MinusIcon
} from "@dealer-center/core-components";
import { useSearchParams } from "react-router-dom";
import {
  AdvancedFiltersSelectionWrapper,
  StyledFilter
} from "./AdvancedFiltersStyles";
import type {
  FiltersConfig,
  SelectedFilterEntry
} from "@dealer-center/ddc-pages-inventory-archiver-interface";

interface AdvancedFiltersContainerProps {
  selectedFilters: SelectedFilterEntry[];
  handleRemoveFilter: (filterName: string) => void;
  filters: FiltersConfig;
}

const AdvancedFiltersContainer = (props: AdvancedFiltersContainerProps) => {
  const [searchParams] = useSearchParams();

  return (
    <AdvancedFiltersSelectionWrapper>
      {props.selectedFilters?.length > 0 &&
        props.selectedFilters.map((selectedFilter, index) => (
          <StyledFilter key={selectedFilter.name}>
            <FilterInput
              clearButton={true}
              label={selectedFilter.name}
              layout={"vertical"}
              name={props.filters[selectedFilter.name].label}
              sx={{ flexDirection: "column", marginTop: "auto" }}
              value={
                searchParams
                  .get(selectedFilter.name.toUpperCase())
                  ?.toString() || ""
              }
              onChange={(
                event: InterstateOnChangeEvent<SearchInputChangeEventValue>
              ) => {
                selectedFilter.value = event.target?.value?.trim() || "";
              }}
            />
            <IconButton
              buttonStyle="primary"
              size="md"
              onClick={() => props.handleRemoveFilter(selectedFilter.name)}
            >
              <MinusIcon title="Remove" />
            </IconButton>
          </StyledFilter>
        ))}
    </AdvancedFiltersSelectionWrapper>
  );
};

export default AdvancedFiltersContainer;
